<div class="uic-fsmicon-wrapper" [ngClass]="nzSize + ' ' + nzClass">
    <ng-content></ng-content>
</div>
